//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.NcmSubopBuilder.js";
import "../CAM/CAM.TurnAvoidanceApproachBuilder.js";
import "../CAM/CAM.TurnAvoidanceClearanceBuilder.js";
import "../CAM/CAM.TurnAvoidanceDepartureBuilder.js";
import "../CAM/CAM.TurnAvoidanceFromBuilder.js";
import "../CAM/CAM.TurnAvoidanceGohomeBuilder.js";
import "../CAM/CAM.TurnAvoidanceReturnBuilder.js";
import "../CAM/CAM.TurnAvoidanceStartBuilder.js";
import "../CAM/CAM.TurnAvoidanceStartOfEngageBuilder.js";
import "../CAM/CAM.Cutcom.js";
import "../CAM/CAM.NcmHoleMachining.js";
let d=[[[0,"AvoidanceAfterLastRetract",1,0],[1,"AvoidanceApproachBuilder",0,"CAM.TurnAvoidanceApproachBuilder",0],[0,"AvoidanceBetweenRegions",1,0],[1,"AvoidanceClearanceBuilder",0,"CAM.TurnAvoidanceClearanceBuilder",0],[1,"AvoidanceDepartureBuilder",0,"CAM.TurnAvoidanceDepartureBuilder",0],[1,"AvoidanceFromBuilder",0,"CAM.TurnAvoidanceFromBuilder",0],[1,"AvoidanceGohomeBuilder",0,"CAM.TurnAvoidanceGohomeBuilder",0],[1,"AvoidanceReturnBuilder",0,"CAM.TurnAvoidanceReturnBuilder",0],[1,"AvoidanceStartBuilder",0,"CAM.TurnAvoidanceStartBuilder",0],[1,"AvoidanceStartOfEngageBuilder",0,"CAM.TurnAvoidanceStartOfEngageBuilder",0],[0,"AvoidanceToStartOfEngage",1,0],[1,"Cutcom",0,"CAM.Cutcom",0],[1,"NcmHoleMachiningBuilder",0,"CAM.NcmHoleMachining",0]],[],[]];
SPLM.CAM.NcmTurningBuilder = class extends SPLM.CAM.NcmSubopBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.NcmTurningBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;